<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addBusinessRouterName" />
        <button-delete @deleteSelection="deleteSelection" />
      </div>
      <input-search placeholder="标题" @search="searchKey" />
    </div>
    <table-main :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine" :deleteTipInfo="'是否确认删除荣誉资质？'" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" />
  </div>
</template>

<script>
import Breadcrumb from '../../../../../components/Breadcrumb/Breadcrumb'
import ButtonAdd from '../../../../../components/Button/ButtonAdd'
import ButtonDelete from '../../../../../components/Button/ButtonDelete'
import ButtonExport from '../../../../../components/common/buttons/button-export'
import ButtonUpload from '../../../../../components/common/buttons/button-upload'
import InputSearch from '../../../../../components/Input/InputSearch'
import InputSelect from '../../../../../components/Input/InputSelect'
import TableMain from '../../../../../components/Table/TableMain'
import {api} from '../../../../api/Summary'
import {errorHandler} from '../../../../../utils/errorHandler'
import {nAlert, nSuccess} from '../../../../../utils/notice'
import {bus} from '../../../../../utils/bus'

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb},
  name: 'honor-qualification-manage',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [{
        value: '信息发布',
        name: 'group-profile-info'
      }, {
        value: '荣誉资质'
      }],
      addBusinessRouterName: 'upper-information-add-honor-qualification',

      operationArr: ['modify', 'delete'],
      tableHead: [{
        prop: 'title',
        label: '标题'
      }, {
        prop: 'obtainTime',
        label: '获取时间'
      }, {
        prop: 'descrpition',
        label: '描述'
      }],
      tableData: [],
      total: 0,
      selectionArr: [],
      requestData: {
        searchKey: '',
        pageSize: 10,
        pageNum: 1,
      },
    }
  },
  created () {
    this.getPage()
  },
  methods: {
    getPage () {
      this.$axios.post(api.getGroupHonorPage, this.requestData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list
            this.total = res.data.data.total
            this.tableData = data
          }
        })
        .catch(errorHandler('获取信息失败'))
    },
    search (v) {
      this.requestData.pageNum = 1
      this.requestData[v.key] = v.value
      this.getPage()
    },
    searchKey (v) {
      this.requestData.pageNum = 1
      this.requestData.searchKey = v
      this.getPage()
    },
    changePagination (data) {
      this.requestData.pageNum = data[0]
      this.requestData.pageSize = data[1]
      this.getPage()
    },
    changeSelection (codeArr) {
      this.selectionArr = codeArr
    },
    goToModifyPage (code) {
      this.$router.push({
        path: `/upper_strata/information/modify_honor_qualification/${code}`
      })
    },
    deleteSelection () {
      if (this.selectionArr.length === 0) {
        nAlert('请先选择需要删除的荣誉资质')
        return false
      } else {
        this.$confirm('是否确认删除荣誉资质？', '提示')
          .then(() => {
            this.deleteLine(this.selectionArr)
          })
          .catch(() => {
            console.log('取消删除')
          })
      }
    },
    deleteLine (code) {
      this.$axios.post(api.deleteGroupHonor, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('删除成功')
            this.selectionArr = []
            this.getPage()
          }
        })
        .catch(errorHandler('删除失败'))
    },
  },
  watch: {}
}
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>



// WEBPACK FOOTER //
// src/view/UpperStrata/Summary/InformationDelivery/HonorQualification/HonorQualificationManage.vue